<div id="login" class="popOver" [class.login-sheet-form]="insideSheet()">
  <h2>{{ 'components.login_form.title' | translate }}</h2>
  <button class="dismiss" type="button" aria-label="Cerrar formulario" (click)="dismiss()">
    X
  </button>
  <hr class="my-2" />
  <form [formGroup]="formLogin()">
    <div class="form-group">
      <label class="control-label">
        {{ 'components.register_form.username' | translate }}
      </label>
      <input
        type="text"
        class="form-control"
        formControlName="username"
        appFormValidation
        [placeholder]="
          formLogin().get('username')?.hasError('required') && formLogin().get('username')?.touched
            ? ('components.login_error.username' | translate)
            : ''
        "
      />
    </div>

    <div class="form-group">
      <label class="control-label">{{ 'password' | translate }}</label>
      <div class="content-input position-relative d-flex align-items-center">
        <input
          #passwordInput
          [type]="showPassword() ? 'text' : 'password'"
          class="form-control"
          formControlName="password"
          appFormValidation
          [placeholder]="
            formLogin().get('password')?.hasError('required') &&
            formLogin().get('password')?.touched
              ? ('components.login_error.password' | translate)
              : ''
          "
        />
        <button
          class="hidden-password dark-blue-text position-absolute end-0 me-2 p-0 bg-transparent"
          type="button"
          (click)="togglePasswordVisibility()"
        >
          <i class="fa {{ showPassword() ? 'fa-eye-slash' : 'fa-eye' }} fs-6"></i>
        </button>
      </div>
      @if (loginFail()) {
        <p class="error">{{ '$login_error_message' | translate }}</p>
      }
    </div>
    <small class="d-block text-end mb-2">
      <a class="cursor-pointer dark-blue-text" (click)="openForgotModal()">
        {{ 'forgot_password' | translate }}
      </a>
    </small>
    <button class="full dark-blue mb-2" (click)="authenticate()">
      {{ 'components.login_form.login' | translate }}
    </button>
    @if (socialLoginEnabled) {
      <button class="full mb-2 btn-google" (click)="loginWithProvider('google')">
        <img class="me-2" lazyLoad="/img/icons/google.svg" height="20" alt="google" />
        {{ 'Ingresar con Google' | translate }}
      </button>
      <button
        class="full mb-2 btn-facebook d-flex align-items-center justify-content-center"
        (click)="loginWithProvider('facebook')"
      >
        <i class="inm-icon-facebook2 fs-6 me-2"></i>
        {{ 'Ingresar con Facebook' | translate }}
      </button>
    }
    <small class="d-block text-center">
      <a class="cursor-pointer dark-blue-text" (click)="openRegisterForm(registerForm)">
        {{ 'create_new_account' | translate }}
      </a>
    </small>
  </form>
</div>

<ng-template #registerForm let-modal>
  <app-register-form [modalRef]="modal" />
</ng-template>
